import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { NotFound, RouteWithSubRoutes } from '@cordata/buffet';

const ReferenceAdminRoot = ({ routes }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      {routes.map(r => (
        <RouteWithSubRoutes key={r.path} {...r} path={`${path}/${r.path}`} />
      ))}

      <Route path="*"><NotFound isRoute /></Route>
    </Switch>
  );
};

ReferenceAdminRoot.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ReferenceAdminRoot;

